import { ImageType } from 'react-images-uploading';

import { CroppedArea } from '../../types';

export enum HorizontalAlignment {
    LEFT = 'left',
    CENTER = 'center',
    RIGHT = 'right',
}

export enum VerticalAlignment {
    TOP = 'flex-start',
    MIDDLE = 'center',
    BOTTOM = 'flex-end',
}

export interface GalleryItem extends ImageType {
    label?: string;
    horizontalAlignment?: HorizontalAlignment;
    verticalAlignment?: VerticalAlignment;
    color?: string;
    imageId?: string;
    croppedArea?: CroppedArea;
}
